import React, { Component } from "react";
class Header extends Component {
  render() {
    return (
      <div>
        <nav>
          <div className="nav-wrapper #e53935 red darken-1">
            <a href="!#" className="brand-logo center " style={{fontFamily: 'Fredoka One, cursive',width:"100%"}}>
              COVID-19 Tracker
            </a>
          </div>
        </nav>
      </div>
    );
  }
}
export default Header;
